import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Col, Container } from 'react-bootstrap';
import TransactionsSearch from './search/TransactionsSearch';
import TransactionsTable from './table/TransactionsTable';
import PageBreadcrumb from '../common/components/layout/PageBreadcrumb';
import { useQueryString, setQueryString } from '../common/helpers/queryString';
import { searchTransactions, generateTransactionsCSV } from './TransactionsActions';
import RouterPaths from '../constants/RouterPaths';
import { PrepareUrl } from '../common/helpers/PrepareUrl';
import { getDealer } from '../dealers/DealersActions';

let breadcrumbs = [];

function TransactionsPage() {
  const { dealerId } = useParams();
  const query = useQueryString();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const items = useSelector((state) => state.transactions.get('items'));
  const totalItems = useSelector((state) => state.transactions.get('totalItems'));
  const dealerDetails = useSelector((state) => state.dealers.get('dealerDetails'));

  const [dealerName, setDealerName] = useState(null);
  const [searchParams, setSearchParams] = useState({
    offset: query.get('page') ? +query.get('page') - 1 : 0,
    dealerId: dealerId || null,
  });

  useEffect(() => {
    if (dealerId) {
      dispatch(getDealer(dealerId));
    } else {
      setDealerName(null);
    }
  }, [dispatch, dealerId]);

  useEffect(() => {
    if (dealerId && dealerDetails?.organization) {
      setDealerName(dealerDetails.organization.officialCompanyName || '');
    }
  }, [dealerDetails, dealerId]);

  useEffect(() => {
    setSearchParams((prevState) => ({
      ...prevState,
      dealerId: dealerId || null,
    }));
  }, [dealerId]);

  useEffect(() => {
    dispatch(searchTransactions(searchParams));
  }, [dispatch, searchParams]);

  const handleSearch = (values, { setSubmitting }) => {
    setSearchParams((prevState) => ({ ...prevState, ...values, offset: 0 }));
    setSubmitting(false);
  };

  const handleDownloadCSV = () => {
    dispatch(generateTransactionsCSV(searchParams));
  };

  const changeOffset = (value) => {
    setSearchParams((prevState) => ({
      ...prevState,
      offset: value,
    }));
    navigate(setQueryString(location, 'page', value + 1));
  };

  if (dealerId) {
    breadcrumbs = [
      { id: 1, type: 'home' },
      { id: 2, type: 'link', text: 'Dealers', url: RouterPaths.DEALERS },
      {
        id: 3,
        type: 'link',
        text: 'Edit Dealer',
        url: PrepareUrl(RouterPaths.DEALER_INFORMATION, { id: dealerId }),
      },
      { id: 4, type: 'span', text: 'Transactions' },
    ];
  } else {
    breadcrumbs = [
      { id: 1, type: 'home' },
      { id: 2, type: 'span', text: 'Transactions' },
    ];
  }

  return (
    <Container fluid>
      <PageBreadcrumb items={breadcrumbs} pageTitle="Transactions" />
      <TransactionsSearch onSearch={handleSearch} dealerName={dealerName} />
      <Col className="d-flex justify-content-end mb-3">
        <Button
          className="rounded-pill btn-primary float-end"
          type="button"
          onClick={handleDownloadCSV}
        >
          Download CSV
        </Button>
      </Col>
      <TransactionsTable
        data={{ items, total: totalItems }}
        offset={searchParams.offset}
        changeOffset={changeOffset}
        refreshData={() => {
          dispatch(searchTransactions(searchParams));
        }}
      />
    </Container>
  );
}

export default TransactionsPage;
